import { Button, Checkbox, Empty, message, Space, Tag, Upload } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import utils from '../../../utils'
import date_format from '../../../date_format'
import {
  TrashBin2OutlineIcon,
  UploadMinimalisticOutlineIcon,
} from '../../../components/AppIcon'
import { blue } from '../../../color'
import { CommentOutlined } from '@ant-design/icons'
import { EmptyText } from '../../../components/Common/CellText'
import RichText from '../../../components/RichEditor/RichText'
import FileItem from '../../../components/Common/FileItemComponent/FileItem'
import CommentEditor from '../../../components/RichEditor/CommentEditor'
import UploadFileItem from '../../../components/Common/FileItemComponent/UploadFileItem'

const WorkDetailCommentList = props => {
  const { workStore, loadingAnimationStore, fileStore } = props

  const { workDetail, commentWorkList } = workStore || {}

  const [isShowDeletedComment, setIsShowDeletedComment] = useState(false)

  const textEditorRef = useRef(null)
  const [fileList, setFileList] = useState([])
  const [disabledSubmitBtn, setDisabledSubmitBtn] = useState(true)

  const commentList = useMemo(() => {
    if (isShowDeletedComment) {
      return commentWorkList
    }
    return commentWorkList?.filter(item => !item.deleted)
  }, [commentWorkList, isShowDeletedComment])

  const handleDeleteComment = async (code_work, comment_id) => {
    try {
      loadingAnimationStore.showSpinner(true)
      await workStore.deleteCommentWork(code_work, comment_id)
      message.success('Xóa ý kiến thành công!')
      await workStore.getCommentWorkList(code_work)
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const usePrevious = value => {
    const ref = useRef()
    useEffect(() => {
      ref.current = value
    })
    return ref.current
  }

  const useHasChanged = val => {
    const prevVal = usePrevious(val)
    return prevVal !== val
  }

  const fileListChanged = useHasChanged(fileList)

  useEffect(() => {
    if (fileListChanged) {
      onHandleChange()
    }
  })

  const onHandleChange = () => {
    let comment =
      (textEditorRef.current &&
        textEditorRef.current.editor &&
        textEditorRef.current.editor.getData()) ||
      ''
    if (!utils.isNullish(comment) || (fileList && fileList.length > 0)) {
      setDisabledSubmitBtn(false)
    } else {
      setDisabledSubmitBtn(true)
    }
  }
  const handleChangeFile = info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
    onHandleChange()
  }

  const handleRemoveFileFromUploadList = fileUID => {
    const newFileList = fileList.filter(file => file.uid !== fileUID)
    setFileList(newFileList)
  }

  const handleCreateComment = async () => {
    if (!textEditorRef?.current?.editor) return
    try {
      loadingAnimationStore.showSpinner(true)
      let comment = textEditorRef?.current?.editor?.getData()

      const uploadFileList = fileList
        ? fileList.map(file => file.originFileObj)
        : []
      const batchUploadArr = []
      uploadFileList.forEach(file => {
        const formData = new FormData()
        formData.append('file', file)
        batchUploadArr.push(fileStore.uploadFile(formData))
      })
      const response = await Promise.all(batchUploadArr)
      const uploadedFiles = response.map(response => response.data.file_id)
      const commentData = {
        content: comment,
        file_ids: uploadedFiles,
      }
      await workStore.createCommentWork(workDetail?.code, commentData)
      await workStore.getCommentWorkList(workDetail?.code)

      textEditorRef.current.editor.setData('')
      setFileList([])
      message.success('Đăng ý kiến thành công!')
    } catch (err) {
      message.error(err?.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  return (
    <div>
      <Space
        style={{
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 12,
        }}>
        <h3 style={{ marginBottom: 0, fontSize: 14, fontWeight: 600 }}>
          Danh sách ý kiến
        </h3>
        <Checkbox
          checked={isShowDeletedComment}
          onChange={e => setIsShowDeletedComment(e.target.checked)}>
          Hiện ý kiến đã xóa
        </Checkbox>
      </Space>
      <div
        style={{
          maxHeight: 500,
          overflowY: 'auto',
        }}>
        {commentList?.length === 0 ? (
          <Empty
            style={{ color: '#ccc' }}
            image={<CommentOutlined style={{ fontSize: '60px' }} />}
            imageStyle={{ height: 60 }}
            description={<EmptyText>Không có ý kiến</EmptyText>}></Empty>
        ) : (
          commentList?.map(item => {
            const {
              comment_id,
              content,
              created_at,
              deleted,
              files,
              name_uppercase,
            } = item || {}

            return (
              <div
                key={comment_id}
                style={{
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  padding: '12px',
                  marginBottom: '12px',
                }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    marginBottom: 8,
                    gap: 8,
                  }}>
                  <p style={{ marginBottom: 0, marginRight: 'auto' }}>
                    {utils.getNameInCapitalize(name_uppercase)}
                  </p>
                  <p
                    style={{
                      marginBottom: 0,
                      fontSize: 12,
                      color: '#BFBFBF',
                      marginTop: deleted ? 3 : 4,
                    }}>
                    {date_format.renderTime(created_at)}
                  </p>
                  {deleted ? (
                    <Tag
                      style={{
                        marginRight: 0,
                        fontSize: 10,
                        borderRadius: '4px',
                      }}
                      color={'red'}>
                      Đã xóa
                    </Tag>
                  ) : (
                    <Button
                      icon={
                        <TrashBin2OutlineIcon
                          style={{
                            color: blue,
                            width: 18,
                            height: 18,
                          }}
                        />
                      }
                      type="text"
                      shape="circle"
                      onClick={() =>
                        handleDeleteComment(workDetail?.code, comment_id)
                      }
                    />
                  )}
                </div>
                {!!content && <RichText htmlText={content.trim()} />}
                {!!files?.length && (
                  <div style={{}}>
                    {files
                      ? files.map(file => (
                          <FileItem
                            key={file.file_id}
                            file_id={file.file_id}
                            file_name={file.file_name}
                            file_type={utils.getExtensionFile(file.file_name)}
                            deleted={deleted}
                          />
                        ))
                      : []}
                  </div>
                )}
              </div>
            )
          })
        )}
      </div>
      <div>
        <Space
          style={{
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 8,
          }}>
          <span>Nhập ý kiến</span>
          <Upload
            style={{ marginLeft: 4, marginRight: 4 }}
            valuePropName={'fileList'}
            fileList={fileList}
            multiple={true}
            onChange={handleChangeFile}
            beforeUpload={() => false}
            showUploadList={false}>
            <Button
              type="text"
              className="custom-ant-button icon-btn"
              htmlType={'button'}
              style={{ color: blue }}
              icon={
                <UploadMinimalisticOutlineIcon
                  style={{ width: 18, height: 18 }}
                />
              }>
              Tải file
            </Button>
          </Upload>
        </Space>
        <div style={{ width: '100%' }}>
          <div style={{ background: '#ffffff', borderRadius: 8 }}>
            <CommentEditor
              EDITOR_REF={textEditorRef}
              placeholder={'Nhập nội dung...'}
              editorContent={''}
              height={162}
              onHandleChange={onHandleChange}
            />
          </div>
          {fileList.length !== 0 && (
            <div
              style={{
                marginTop: 8,
              }}>
              {fileList.map(file => (
                <UploadFileItem
                  key={file.uid}
                  file_id={file.uid}
                  file_name={file.name}
                  file_type={utils.getExtensionFile(file.name)}
                  handleRemoveFileFromUploadList={() =>
                    handleRemoveFileFromUploadList(file.uid)
                  }
                />
              ))}
            </div>
          )}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: 28,
            }}>
            <Button
              className="custom-ant-button"
              type={'default'}
              style={
                !disabledSubmitBtn
                  ? {
                      borderColor: blue,
                      color: blue,
                    }
                  : {}
              }
              onClick={handleCreateComment}
              disabled={disabledSubmitBtn}>
              Đăng ý kiến
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default inject(
  'workStore',
  'fileStore',
  'loadingAnimationStore',
  'aclStore'
)(observer(WorkDetailCommentList))
